import React from 'react';
import { observer } from 'mobx-react';
import { FaqCategoryStore } from '@seedlang/stores';
import CreateWithTitle from 'components/creator/create_with_title';

@observer
class FaqCategoryCreate extends React.Component {

  onCreate = name => {
    FaqCategoryStore.create({ data: { name } }, this.props.afterCreate);
  };

  render() {
    return (
      <CreateWithTitle
        placeholder='Add a category name'
        onCreate={this.onCreate}
      />
    );
  }
}

export default FaqCategoryCreate;
